<template>
  <canvas id="customerActivityChart-message-chart" height="400"></canvas>
</template>

<script>
import { Chart } from "chart.js";
// import ChartDataLabels from "chartjs-plugin-datalabels";

export default {
  name: "CustomerActivityChart",
  props: {
    data: {
      type: Object,
      require: true,
    },
    yAxisTitle: {
      type: String,
      require: true,
    },
    maxValue: {
      type: Number,
      require: false,
      default: 0,
    },
  },
  data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        parsing: {
          xAxisKey: "name",
          yAxisKey: "count",
        },
        layout: {
          padding: 0,
        },
        scales: {
          y: {
            ticks: {
              beginAtZero: true,
              callback: (value) => {
                if (value % 1 === 0) {
                  return value;
                }
              },
            },
            suggestedMax: this.maxValue,
            title: {
              display: true,
              align: "center",
              text: "Customer",
              color: "#242424",
              font: {
                family: "Kanit-Regular",
                size: 12,
                lineHeight: 2,
              },
              padding: { top: 0, left: 0, right: 0, bottom: 10 },
            },
          },
          x: {
            ticks: {
              beginAtZero: true,
            },
            title: {
              display: true,
              align: "center",
              text: this.yAxisTitle,
              color: "#242424",
              font: {
                family: "Kanit-Regular",
                size: 12,
                lineHeight: 2,
              },
              padding: { top: 0, left: 0, right: 0, bottom: 10 },
            },
          },
        },
        interaction: {
          intersect: false,
          mode: "index",
        },
        plugins: {
          // datalabels: {
          //   display: (context) => {
          //     const index = context.dataIndex;
          //     const isShow = context.dataset.data[index].count;
          //     return isShow ? "auto" : false;
          //   },
          //   textAlign: "top",
          //   anchor: "end",
          //   align: "top",
          //   offset: -5,
          //   font: {
          //     size: 12,
          //   },
          //   formatter: (value, context) => {
          //     let data = this.addCommas(value.count);
          //     return data;
          //   },
          // },
          legend: {
            display: true,
            position: "bottom",
            labels: { boxWidth: 10, boxHeight: 10 },
          },
          tooltip: {
            // external: externalTooltipHandler,
            bodyAlign: "left",
            yAlign: "bottom",
            titleColor: "#fff",
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            titleMarginBottom: 5,
            padding: 12,
            callbacks: {
              title: (context) => {
                const contextElement = context[0];
                const label = contextElement.label;
                const labelCollect = [];
                const title = `${label}`;

                return [title, ...labelCollect].join("\n");
              },
              labelColor: (context) => {
                return {
                  backgroundColor: context.dataset.labelBackgroundColor,
                };
              },
              label: (context) => {
                const contextElement = context;
                const labelCollect = [];
                const index = contextElement.dataIndex;
                let total = contextElement.dataset.data[index].total;
                labelCollect.push(`Total Customer ${total}`);

                return [labelCollect].join("\n");
              },
              afterLabel: (context) => {
                return;
              },
            },
          },
        },
      },
      gradient: null,
    };
  },
  mounted() {
    const ctx = document
      .getElementById("customerActivityChart-message-chart")
      .getContext("2d");
    const gradientColor1 = ctx.createLinearGradient(0, 0, 0, 350);
    gradientColor1.addColorStop(0, "rgba(113, 96,196, 0.5)");
    gradientColor1.addColorStop(0.5, "rgba(113, 96, 196, 0.25)");
    gradientColor1.addColorStop(1, "rgba(113, 96, 196, 0)");

    const gradientColor2 = ctx.createLinearGradient(0, 0, 0, 350);
    gradientColor2.addColorStop(0, "rgba(0, 231, 255, 0.9)");
    gradientColor2.addColorStop(0.5, "rgba(0, 231, 255, 0.25)");
    gradientColor2.addColorStop(1, "rgba(0, 231, 255, 0)");
    new Chart(ctx, {
      type: "line",
      data: {
        datasets: [
          {
            type: "line",
            label: "Total Customer",
            order: 0,
            backgroundColor: gradientColor1,
            borderColor: "#7160C4",
            // pointBackgroundColor:
            //   this.data.chatCreated.length > 1 ? "transparent" : "#7160C4",
            // pointBorderColor:
            //   this.data.chatCreated.length > 1 ? "transparent" : "#7160C4",
            labelBackgroundColor: "#7160C4",
            data: this.data.customer,
            tension: 0.4,
            fill: true,
          },
        ],
      },
      // plugins: [ChartDataLabels],
      options: this.options,
    });
  },
  methods: {
    addCommas(nStr) {
      var x, x1, x2;

      nStr += "";
      x = nStr.split(".");
      x1 = x[0];
      x2 = x.length > 1 ? "." + x[1] : "";
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
      }
      return x1 + x2;
    },
  },
};
</script>

<style lang="scss" scoped></style>
